// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Agenda_AplicarCoresOperadoresInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /agenda/aplicar_cores_operadores
 *
 * Validates input for applying background colors to operators.
 * The cores property is an associative array where keys are user IDs
 * and values are hex color strings: {"user_id_1": "#FF0000", "user_id_2": "#00FF00"}
 */
import { registerContract } from './validate'

export interface Agenda_AplicarCoresOperadoresInput {
cores?: Record<string, string>
}

registerContract('Agenda_AplicarCoresOperadoresInput', {
  cores: { type: 'object',  required: false },
})
